import React from 'react';
import { Button } from 'react-bootstrap';
import { useEnrollmentFilanizer } from '../hooks/use-enrollment-finalizer';
import { useCourseEnrollees } from '../hooks/use-course-enrollees';
import BusyModal from '../../../components/modals/busy';

const useCommitButton = () => {
    const { courseEnrollees } = useCourseEnrollees();
    const {
        finalizeEnrollment,
        isLoading
    } = useEnrollmentFilanizer();
    const disabled = !courseEnrollees.length || isLoading;
    const onClick = () => finalizeEnrollment();
    const label = isLoading ? 'Committing...' : 'Commit Auto Enrollment';
    return {
        disabled,
        onClick,
        label,
        isLoading
    };
};

export const CommitButton = () => {
    const { onClick, disabled, label, isLoading } = useCommitButton();
    return (
        <>
            <BusyModal
                title='Enrolling students...'
                centered
                visible={isLoading}
            />
            <Button onClick={onClick} disabled={disabled}>
                {label}
            </Button>
        </>
    );
};
